import React, {useState} from "react";
import {Button} from "reactstrap";
import {connect} from "react-redux";
import {Email} from "models/Email";
import {markEmailAsSpam} from "store/actions/Emails";
import {useOfficeTranslation} from "i18n/OfficeTranslation";

interface Props {
    emails: Email[];
    onMoved?: (id: string) => void;
    disabled?: boolean;
    iconOnly?: boolean;
}

export const MarkAsSpamButton = ({emails, onMoved, disabled, iconOnly = false, markEmailAsSpam}: Props & {
    markEmailAsSpam: (email: Email) => Promise<unknown>;
}) => {
    const {t} = useOfficeTranslation();
    const [pending, setPending] = useState(false);
    const [failed, setFailed] = useState(false);
    if (emails.length === 0 || emails.some(email => email.direction !== "in")) return null;

    const mark = async () => {
        setPending(true);
        setFailed(false);
        try {
            for (const email of emails) {
                await markEmailAsSpam(email);
                onMoved?.(email.id);
            }
        } catch {
            setFailed(true);
        } finally {
            setPending(false);
        }
    };

    return <>
        <Button color={iconOnly ? "light" : "warning"} size="sm" disabled={pending || disabled} onClick={mark}
            className={iconOnly ? "email-detail__action" : undefined}
            title={t("email.markAsSpam")} aria-label={t("email.markAsSpam")} aria-busy={pending}>
            <i className={iconOnly ? "mdi mdi-shield-alert-outline" : "mdi mdi-alert-octagon"} aria-hidden="true" />
            {!iconOnly && t("email.markAsSpam")}
        </Button>
        {failed && <span role="alert" className="text-danger ms-2">{t("email.spamFailed")}</span>}
    </>;
};

export default connect(null, {markEmailAsSpam})(MarkAsSpamButton);
